const SYSTEM_MODE_CRIA = "cria";
const SYSTEM_MODE_CICLO_COMPLETO = "ciclo_completo";

const normalizeSystemMode = (mode) =>
  mode === SYSTEM_MODE_CRIA ? SYSTEM_MODE_CRIA : SYSTEM_MODE_CICLO_COMPLETO;

export class Simulador {
  constructor(valoresIniciais = {}) {
    this.systemMode = normalizeSystemMode(valoresIniciais.systemMode);
    //ÃNDICES ZOOTÃ‰CNICOS -- [VALIDADO]
    this.desmame = valoresIniciais.desmame ?? 60;
    this.mortalidade = valoresIniciais.mortalidade ?? 3;
    this.touros = valoresIniciais.touros ?? 4;
    this.idade_venda = this.is_cria() ? 1 : (valoresIniciais.idade_venda ?? 3);
    this.idade_entoure = valoresIniciais.idade_entoure ?? 2;
    this.lotacao = valoresIniciais.lotacao ?? 0.7;
    this.unidade_animal = valoresIniciais.unidade_animal ?? 450;
    this.preco_venda = valoresIniciais.preco_venda ?? 11.70;
    this.desembolso_cabeca_mes = valoresIniciais.desembolso_cabeca_mes ?? 60;

    // PreÃ§os de venda por categoria (R$/kg PV)
    this.preco_venda_novilhos  = valoresIniciais.preco_venda_novilhos  ?? this.preco_venda;
    this.preco_venda_novilhas  = valoresIniciais.preco_venda_novilhas  ?? this.preco_venda;
    this.preco_venda_vacas_desc  = valoresIniciais.preco_venda_vacas ?? valoresIniciais.preco_venda_vacas_desc ?? this.preco_venda;
    this.preco_venda_touros_desc = valoresIniciais.preco_venda_touros ?? valoresIniciais.preco_venda_touros_desc ?? this.preco_venda;
    this.precos_personalizados = [
      valoresIniciais.preco_venda_novilhos,
      valoresIniciais.preco_venda_novilhas,
      valoresIniciais.preco_venda_vacas,
      valoresIniciais.preco_venda_vacas_desc,
      valoresIniciais.preco_venda_touros,
      valoresIniciais.preco_venda_touros_desc,
    ].some((valor) => valor !== undefined && valor !== null);

    //Metas
    this.vacas = 300;
    this.tmf = 180;
    this.novilho = 200;
    this.area_pastagem = valoresIniciais.area_pastagem ?? valoresIniciais.area ?? 500;
    //ParamÃªtros de calibraÃ§Ã£o



    //ParamÃªtros optativos - em Percentual -- [VALIDADO]
    this.descarte_vacas_ano = 20;
    this.descarte_touros_ano = 25;

    //Pesos mÃ©dios das categorias em estoque - em KG
    if (this.is_cria()) {
      this.peso_medio_vacas = 420;
      this.peso_medio_novilha_3 = 350;
      this.peso_medio_novilha_2 = 300;
      this.peso_medio_novilha_1 = 250;
      this.peso_medio_novilho_3 = 360;
      this.peso_medio_novilho_2 = 360;
      this.peso_medio_novilho_1 = 320;
      this.peso_medio_bezerros = 130;
      this.peso_medio_bezerras = 110;
      this.peso_medio_touros = 650;
      this.peso_venda_vacas = 500;
      this.peso_venda_novilha_3 = 470;
      this.peso_venda_novilha_2 = 420;
      this.peso_venda_novilha_1 = 320;
      this.peso_venda_novilho_3 = 460;
      this.peso_venda_novilho_2 = 460;
      this.peso_venda_novilho_1 = 440;
      this.peso_venda_bezerros = 190;
      this.peso_venda_bezerras = 170;
      this.peso_venda_touros = 825;
    } else {
      this.peso_medio_vacas = 450;
      this.peso_medio_novilha_3 = 370;
      this.peso_medio_novilha_2 = 370;
      this.peso_medio_novilha_1 = 270;
      this.peso_medio_novilho_3 = 360;
      this.peso_medio_novilho_2 = 360;
      this.peso_medio_novilho_1 = 320;
      this.peso_medio_bezerros = 190;
      this.peso_medio_bezerras = 170;
      this.peso_medio_touros = 650;
      this.peso_venda_vacas = 500;
      this.peso_venda_novilha_3 = 420;
      this.peso_venda_novilha_2 = 420;
      this.peso_venda_novilha_1 = 320;
      this.peso_venda_novilho_3 = 460;
      this.peso_venda_novilho_2 = 460;
      this.peso_venda_novilho_1 = 440;
      this.peso_venda_bezerros = 420;
      this.peso_venda_bezerras = 220;
      this.peso_venda_touros = 825;
    }

    this.peso_medio_machos = 0;
    this.peso_medio_femeas = 0;
    this.peso_medio_total = 0;

    //ESTOQUE ANIMAL - percentual de cabeÃ§as / percentual de unidade animal por Ã¡rea // Unidades por Ã¡rea

    //Percentual de cabeÃ§as em Estoque
    this.estoque_percentual_cabecas_vacas = 0;
    this.estoque_percentual_cabecas_novilha_3 = 0;
    this.estoque_percentual_cabecas_novilha_2 = 0;
    this.estoque_percentual_cabecas_novilha_1 = 0;
    this.estoque_percentual_cabecas_novilho_3 = 0;
    this.estoque_percentual_cabecas_novilho_2 = 0;
    this.estoque_percentual_cabecas_novilho_1 = 0;
    this.estoque_percentual_cabecas_bezerros = 0;
    this.estoque_percentual_cabecas_bezerras = 0;
    this.estoque_percentual_cabecas_touros = 0;
    this.estoque_percentual_cabecas_machos = 0;
    this.estoque_percentual_cabecas_femeas = 0;
    this.estoque_percentual_cabecas_total = 100;

    //Percentual por unidade animal em Estoque
    this.estoque_percentual_ua_cabecas_vacas = 0;
    this.estoque_percentual_ua_cabecas_novilha_3 = 0;
    this.estoque_percentual_ua_cabecas_novilha_2 = 0;
    this.estoque_percentual_ua_cabecas_novilha_1 = 0;
    this.estoque_percentual_ua_cabecas_novilho_3 = 0;
    this.estoque_percentual_ua_cabecas_novilho_2 = 0;
    this.estoque_percentual_ua_cabecas_novilho_1 = 0;
    this.estoque_percentual_ua_cabecas_bezerros = 0;
    this.estoque_percentual_ua_cabecas_bezerras = 0;
    this.estoque_percentual_ua_cabecas_touros = 0;
    this.estoque_percentual_ua_cabecas_machos = 0;
    this.estoque_percentual_ua_cabecas_femeas = 0;
    this.estoque_percentual_ua_cabecas_total = 100;

    //Unidade animal por unidade de Ã¡rea
    this.estoque_unidade_cabecas_vacas = 0;
    this.estoque_unidade_cabecas_novilha_3 = 0;
    this.estoque_unidade_cabecas_novilha_2 = 0;
    this.estoque_unidade_cabecas_novilha_1 = 0;
    this.estoque_unidade_cabecas_novilho_3 = 0;
    this.estoque_unidade_cabecas_novilho_2 = 0;
    this.estoque_unidade_cabecas_novilho_1 = 0;
    this.estoque_unidade_cabecas_bezerros = 0;
    this.estoque_unidade_cabecas_bezerras = 0;
    this.estoque_unidade_cabecas_touros = 0;
    this.estoque_unidade_cabecas_machos = 0;
    this.estoque_unidade_cabecas_femeas = 0;
    this.estoque_unidade_cabecas_total = 100;
    this.estoque_relacao_unidade_por_area = 0;

    //Resultados em funÃ§Ã£o das Metas

    //FunÃ§Ã£o meta em relaÃ§Ã£o a percentual de VACAS
    this.vacas_unidades_vacas = 0;
    this.vacas_unidades_novilhos_1 = 0;
    this.vacas_unidades_novilhos_2 = 0;
    this.vacas_unidades_novilhos_3 = 0;
    this.vacas_unidades_novilhas_1 = 0;
    this.vacas_unidades_novilhas_2 = 0;
    this.vacas_unidades_novilhas_3 = 0;
    this.vacas_unidades_bezerros = 0;
    this.vacas_unidades_bezerras = 0;
    this.vacas_unidades_touros = 0;
    this.vacas_unidades_machos = 0;
    this.vacas_unidades_femeas = 0;
    this.vacas_unidades_total = 0;
    this.vacas_unidades_total_UA = 0;
    this.vacas_area_total = 0;

    //FunÃ§Ã£o meta em relaÃ§Ã£o a unidades de Ã¡rea
    this.area_unidades_vacas = 0;
    this.area_unidades_novilhos_1 = 0;
    this.area_unidades_novilhos_2 = 0;
    this.area_unidades_novilhos_3 = 0;
    this.area_unidades_novilhas_1 = 0;
    this.area_unidades_novilhas_2 = 0;
    this.area_unidades_novilhas_3 = 0;
    this.area_unidades_bezerros = 0;
    this.area_unidades_bezerras = 0;
    this.area_unidades_touros = 0;
    this.area_unidades_machos = 0;
    this.area_unidades_femeas = 0;
    this.area_unidades_total = 0;
    this.area_unidades_total_UA = 0;
    this.area_area_total = 0;

  //FunÃ§Ã£o meta em relaÃ§Ã£o a unidades de bezerros
    this.tmf_unidades_vacas = 0;
    this.tmf_unidades_novilhos_1 = 0;
    this.tmf_unidades_novilhos_2 = 0;
    this.tmf_unidades_novilhos_3 = 0;
    this.tmf_unidades_novilhas_1 = 0;
    this.tmf_unidades_novilhas_2 = 0;
    this.tmf_unidades_novilhas_3 = 0;
    this.tmf_unidades_bezerros = 0;
    this.tmf_unidades_bezerras = 0;
    this.tmf_unidades_touros = 0;
    this.tmf_unidades_machos = 0;
    this.tmf_unidades_femeas = 0;
    this.tmf_unidades_total = 0;
    this.tmf_unidades_total_UA = 0;
    this.tmf_area_total = 0;

    //FunÃ§Ã£o meta em relaÃ§Ã£o a unidades de novilhos vendidos
    this.novilho_unidades_vacas = 0;
    this.novilho_unidades_novilhos_1 = 0;
    this.novilho_unidades_novilhos_2 = 0;
    this.novilho_unidades_novilhos_3 = 0;
    this.novilho_unidades_novilhas_1 = 0;
    this.novilho_unidades_novilhas_2 = 0;
    this.novilho_unidades_novilhas_3 = 0;
    this.novilho_unidades_bezerros = 0;
    this.novilho_unidades_bezerras = 0;
    this.novilho_unidades_touros = 0;
    this.novilho_unidades_machos = 0;
    this.novilho_unidades_femeas = 0;
    this.novilho_unidades_total = 0;
    this.novilho_unidades_total_UA = 0;
    this.novilho_area_total = 0;

  //Desfrutes
  this.cria_femeas_bezerro = 0;
    this.desfrute_percentual_cabeca = 0;
    this.desfrute_percentual_kg = 0;

  //ProduÃ§Ã£o Animal - Rebanho estÃ¡vel - em relaÃ§Ã£o a metas
  this.efic_cria_kgBezerro_kgUnidProd = 0;
  this.efic_cria_kgTerneiro_kgUnidProd = 0;
  this.produtividade_por_area = 0;
  this.produtividade_por_vacas = 0;

  //Produtividade do Cria
  this.prod_cria_relacao_femeas_terneiro = 0;
  this.prod_cria_peso_terneiro_desm_hectare = 0;
  this.prod_cria_area_prod_terneiro = 0;
  this.prod_cria_bezerros_desm_vaca_exposta = 0;
  this.prod_cria_bezerros_desm_kg_vaca_exposta = 0;
  this.lotacao_cab_area = 0;

    //Em relaÃ§Ã£o a vacas
    this.prod_vacas_cabeca_novilhos = 0;
    this.prod_vacas_cabeca_novilhas = 0;
    this.prod_vacas_cabeca_vacas_descarte = 0;
    this.prod_vacas_cabeca_touros_descarte = 0;
    this.prod_vacas_cabeca_total_vendas = 0;

    //Em relaÃ§Ã£o a area
    this.prod_area_cabeca_novilhos = 0;
    this.prod_area_cabeca_novilhas = 0;
    this.prod_area_cabeca_vacas_descarte = 0;
    this.prod_area_cabeca_touros_descarte = 0;
    this.prod_area_cabeca_total_vendas = 0;

    //Em relaÃ§Ã£o a tmf
    this.prod_tmf_cabeca_novilhos = 0;
    this.prod_tmf_cabeca_novilhas = 0;
    this.prod_tmf_cabeca_vacas_descarte = 0;
    this.prod_tmf_cabeca_touros_descarte = 0;
    this.prod_tmf_cabeca_total_vendas = 0;

    //Em relaÃ§Ã£o a novilho
    this.prod_novilho_cabeca_novilhos = 0;
    this.prod_novilho_cabeca_novilhas = 0;
    this.prod_novilho_cabeca_vacas_descarte = 0;
    this.prod_novilho_cabeca_touros_descarte = 0;
    this.prod_novilho_cabeca_total_vendas = 0;
  } //Final do constructor

  is_cria() {
    return this.systemMode === SYSTEM_MODE_CRIA;
  }

  set_system_mode(mode) {
    const nextMode = normalizeSystemMode(mode);
    const oldMode = this.systemMode;

    this.systemMode = nextMode;
    if (this.is_cria()) {
      this.idade_venda = 1;
    } else if (this.idade_venda === 1) {
      this.idade_venda = 3;
    }

    if (oldMode !== nextMode) {
      this.reset_calibrar();
    }
  }

  set_preco_venda(cotacao){
    this.preco_venda = cotacao;
  }
  set_area_pastagem(area){
    this.area_pastagem = area;
  }

set_base_info(input_base) {
  // DesestruturaÃ§Ã£o com valores padrÃ£o
  const {
    systemMode = this.systemMode,
    desmame = this.desmame, // MantÃ©m o valor atual se nÃ£o for fornecido
    mortalidade = this.mortalidade,
    touros = this.touros,
    idade_venda = this.idade_venda,
    idade_entoure = this.idade_entoure,
    lotacao = this.lotacao,
    unidade_animal = this.unidade_animal,
    desembolso_cabeca_mes = this.desembolso_cabeca_mes, // Renomeando e com valor padrÃ£o
    preco_venda = this.preco_venda,
    preco_venda_novilhos,
    preco_venda_novilhas,
    preco_venda_vacas,
    preco_venda_touros,
  } = input_base || {}; // Garante que input_base seja um objeto vazio se for undefined/null

  const old_system_mode = this.systemMode;

  this.systemMode = normalizeSystemMode(systemMode);
  this.desmame = desmame;
  this.mortalidade = mortalidade;
  this.touros = touros;
  this.idade_venda = this.is_cria() ? 1 : idade_venda;
  this.idade_entoure = idade_entoure;
  this.lotacao = Math.round(lotacao * 100) / 100; // Sempre 2 casas decimais
  this.unidade_animal = unidade_animal;
  this.desembolso_cabeca_mes = desembolso_cabeca_mes;
  this.preco_venda = preco_venda;

  const precosPersistidos = {
    preco_venda_novilhos,
    preco_venda_novilhas,
    preco_venda_vacas,
    preco_venda_touros,
  };
  if (Object.values(precosPersistidos).some((valor) => valor !== undefined && valor !== null)) {
    this.set_precos_venda(precosPersistidos, { personalizado: true });
  }

  // A idade de venda apenas altera a composição do rebanho. As calibrações
  // (incluindo os pesos de venda) são escolhas do usuário e devem ser mantidas.
  // A redefinição só é necessária quando o modo do sistema é alterado.
  if (old_system_mode !== this.systemMode) {
    this.reset_calibrar();
  }
}

  set_metas(metas = {}){
    this.vacas = metas.vacas ?? this.vacas;
    this.tmf = metas.tmf ?? this.tmf;
    this.novilho = metas.novilho ?? this.novilho;
    this.area_pastagem = metas.area ?? metas.area_pastagem ?? this.area_pastagem;
  }

  set_calibrar(input_calibrar) {
    //FunÃ§Ã£o SETa os valores da calibraÃ§Ã£o quando ocorrerem mudanÃ§as
    // Atualiza percentual de touros caso venha nas configuraÃ§Ãµes
    if (input_calibrar.touros !== undefined) {
      this.touros = input_calibrar.touros;
    }
    //Pesos mÃ©dios das categorias em estoque - em KG
    this.peso_medio_vacas = input_calibrar.peso_medio_vacas;
    this.peso_medio_novilha_3 = input_calibrar.peso_medio_novilha_3;
    this.peso_medio_novilha_2 = input_calibrar.peso_medio_novilha_2;
    this.peso_medio_novilha_1 = input_calibrar.peso_medio_novilha_1;
    this.peso_medio_novilho_3 = input_calibrar.peso_medio_novilho_3;
    this.peso_medio_novilho_2 = input_calibrar.peso_medio_novilho_2;
    this.peso_medio_novilho_1 = input_calibrar.peso_medio_novilho_1;
    this.peso_medio_bezerros = input_calibrar.peso_medio_bezerros || input_calibrar.peso_medio_terneiros;
    this.peso_medio_bezerras = input_calibrar.peso_medio_bezerras || input_calibrar.peso_medio_terneiros;
    this.peso_medio_touros = input_calibrar.peso_medio_touros;

    //Pesos de venda das categorias em estoque - em KG
    this.peso_venda_vacas = input_calibrar.peso_venda_vacas;
    this.peso_venda_novilha_3 = input_calibrar.peso_venda_novilha_3;
    this.peso_venda_novilha_2 = input_calibrar.peso_venda_novilha_2;
    this.peso_venda_novilha_1 = input_calibrar.peso_venda_novilha_1;
    this.peso_venda_novilho_3 = input_calibrar.peso_venda_novilho_3;
    this.peso_venda_novilho_2 = input_calibrar.peso_venda_novilho_2;
    this.peso_venda_novilho_1 = input_calibrar.peso_venda_novilho_1;
    this.peso_venda_bezerros = input_calibrar.peso_venda_bezerros || input_calibrar.peso_venda_terneiros;
    this.peso_venda_bezerras = input_calibrar.peso_venda_bezerras || input_calibrar.peso_venda_terneiros;
    this.peso_venda_touros = input_calibrar.peso_venda_touros;

    //Descartes
    this.descarte_touros_ano = input_calibrar.descarte_touros_ano;
    this.descarte_vacas_ano = input_calibrar.descarte_vacas_ano;
  }

  // Restaura os Ã­ndices zootÃ©cnicos para os valores padrÃ£o do aplicativo
  reset_indices() {
    this.desmame = 60;
    this.mortalidade = 3;
    this.touros = 4;
    this.idade_venda = this.is_cria() ? 1 : 3;
    this.idade_entoure = 2;
    this.lotacao = 0.7;
    this.unidade_animal = 450;
    this.preco_venda = 10.80;
    this.desembolso_cabeca_mes = 60;
    this.area_pastagem = 500;
  }

  /**
   * Define preÃ§os de venda por categoria.
   * @param {object} precos
   */
  set_precos_venda(precos = {}, options = {}) {
    if (precos.preco_venda_novilhos  !== undefined) this.preco_venda_novilhos  = precos.preco_venda_novilhos;
    if (precos.preco_venda_novilhas  !== undefined) this.preco_venda_novilhas  = precos.preco_venda_novilhas;
    if (precos.preco_venda_vacas     !== undefined) this.preco_venda_vacas_desc  = precos.preco_venda_vacas;
    if (precos.preco_venda_touros    !== undefined) this.preco_venda_touros_desc = precos.preco_venda_touros;
    if (options.personalizado !== undefined) {
      this.precos_personalizados = options.personalizado;
    }
  }

  /**
   * Calcula custo anual e custo por kg produzido.
   * @returns {{ custoAnual: number, custoKgProduzido: number }}
   */
  calcularCustos() {
    const custoAnual = (this.desembolso_cabeca_mes ?? 0) * 12 * (this.area_unidades_total || 0);
    const totalKgProduzido = (this.produtividade_por_area || 0) * (this.area_area_total || this.area_pastagem || 1);
    const custoKgProduzido = totalKgProduzido > 0 ? custoAnual / totalKgProduzido : 0;
    return { custoAnual, custoKgProduzido };
  }

  /**
   * Calcula faturamento total por categoria com preÃ§os individuais.
   * @param {object} precos - { preco_venda_novilhos, preco_venda_novilhas, preco_venda_vacas, preco_venda_touros }
   */
  calcularFaturamentoTotal(precos = {}) {
    const {
      preco_venda_novilhos  = this.preco_venda_novilhos,
      preco_venda_novilhas  = this.preco_venda_novilhas,
      preco_venda_vacas     = this.preco_venda_vacas_desc,
      preco_venda_touros    = this.preco_venda_touros_desc,
    } = precos;

    // Peso de venda do novilho depende da idade de venda
    let peso_novilho = this.peso_venda_novilho_2; // padrÃ£o idade 3
    if (this.idade_venda === 1)      peso_novilho = this.peso_venda_bezerros;
    else if (this.idade_venda === 2) peso_novilho = this.peso_venda_novilho_1;

    // Peso de venda da novilha depende da idade de entoure
    let peso_novilha = this.peso_venda_novilha_1; // padrÃ£o idade 2
    if (this.idade_entoure === 1)      peso_novilha = this.peso_venda_bezerras;
    else if (this.idade_entoure === 3) peso_novilha = this.peso_venda_novilha_2;

    const receita_novilhos = (this.prod_area_cabeca_novilhos       || 0) * peso_novilho        * preco_venda_novilhos;
    const receita_novilhas = (this.prod_area_cabeca_novilhas       || 0) * peso_novilha        * preco_venda_novilhas;
    const receita_vacas    = (this.prod_area_cabeca_vacas_descarte || 0) * this.peso_venda_vacas  * preco_venda_vacas;
    const receita_touros   = (this.prod_area_cabeca_touros_descarte || 0) * this.peso_venda_touros * preco_venda_touros;

    return receita_novilhos + receita_novilhas + receita_vacas + receita_touros;
  }

  /**
   * Calcula margem bruta por hectare com preÃ§os individuais.
   * @param {object} precos
   */
  calcularMargemBruta(precos = {}) {
    const { custoAnual } = this.calcularCustos();
    const faturamento = this.calcularFaturamentoTotal(precos);
    const area = this.area_area_total || this.area_pastagem || 1;
    return (faturamento - custoAnual) / area;
  }

  // Restaura os valores de calibraÃ§Ã£o para os padrÃµes do aplicativo
  reset_calibrar() {
    this.descarte_vacas_ano = 20;
    this.descarte_touros_ano = 25;
    this.touros = 4;

    if (this.is_cria()) {
      this.peso_medio_vacas = 450;
      this.peso_medio_novilha_3 = 370;
      this.peso_medio_novilha_2 = 370;
      this.peso_medio_novilha_1 = 340;
      this.peso_medio_novilho_3 = 360;
      this.peso_medio_novilho_2 = 360;
      this.peso_medio_novilho_1 = 320;
      this.peso_medio_bezerros = 120;
      this.peso_medio_bezerras = 110;
      this.peso_medio_touros = 650;
      this.peso_venda_vacas = 550;
      this.peso_venda_novilha_3 = 370;
      this.peso_venda_novilha_2 = 370;
      this.peso_venda_novilha_1 = 340;
      this.peso_venda_novilho_3 = 460;
      this.peso_venda_novilho_2 = 460;
      this.peso_venda_novilho_1 = 440;
      this.peso_venda_bezerros = 190;
      this.peso_venda_bezerras = 170;
      this.peso_venda_touros = 850;
    } else {
      this.peso_medio_vacas = 450;
      this.peso_medio_novilha_3 = 370;
      this.peso_medio_novilha_2 = 370;
      this.peso_medio_novilha_1 = 340;
      this.peso_medio_novilho_3 = 360;
      this.peso_medio_novilho_2 = 360;
      this.peso_medio_novilho_1 = 320;
      this.peso_medio_bezerros = 120;
      this.peso_medio_bezerras = 110;
      this.peso_medio_touros = 650;
      this.peso_venda_vacas = 550;
      this.peso_venda_novilha_3 = 370;
      this.peso_venda_novilha_2 = 370;
      this.peso_venda_novilha_1 = 340;
      this.peso_venda_novilho_3 = 460;
      this.peso_venda_novilho_2 = 460;
      this.peso_venda_novilho_1 = 440;
      this.peso_venda_bezerros = 190;
      this.peso_venda_bezerras = 170;
      this.peso_venda_touros = 850;
    }

    this.preco_venda_novilhos = this.preco_venda;
    this.preco_venda_novilhas = this.preco_venda;
    this.preco_venda_vacas_desc = this.preco_venda;
    this.preco_venda_touros_desc = this.preco_venda;
  }

  calcula_peso_medio_machos() {
    var aux =
      (this.peso_medio_novilho_1 * this.vacas_unidades_novilhos_1 +
        this.peso_medio_novilho_2 * this.vacas_unidades_novilhos_2 +
        this.peso_medio_novilho_3 * this.vacas_unidades_novilhos_3 +
        this.peso_medio_bezerros * this.vacas_unidades_bezerros +
        this.peso_medio_touros * this.vacas_unidades_touros) /
      this.vacas_unidades_machos;

    this.peso_medio_machos = aux;
  }

  calcula_peso_medio_femeas() {
    var aux =
      (this.peso_medio_novilha_1 * this.vacas_unidades_novilhas_1 +
        this.peso_medio_novilha_2 * this.vacas_unidades_novilhas_2 +
        this.peso_medio_novilha_3 * this.vacas_unidades_novilhas_3 +
        this.peso_medio_bezerras * this.vacas_unidades_bezerras +
        this.peso_medio_vacas * this.vacas_unidades_vacas) /
      this.vacas_unidades_femeas;
    this.peso_medio_femeas = aux;
  }

  calcula_peso_medio_total() {
    var aux =
      (this.peso_medio_novilho_1 * this.vacas_unidades_novilhos_1 +
        this.peso_medio_novilho_2 * this.vacas_unidades_novilhos_2 +
        this.peso_medio_novilho_3 * this.vacas_unidades_novilhos_3 +
        this.peso_medio_bezerros * this.vacas_unidades_bezerros +
        this.peso_medio_touros * this.vacas_unidades_touros +
        (this.peso_medio_novilha_1 * this.vacas_unidades_novilhas_1 +
          this.peso_medio_novilha_2 * this.vacas_unidades_novilhas_2 +
          this.peso_medio_novilha_3 * this.vacas_unidades_novilhas_3 +
          this.peso_medio_bezerras * this.vacas_unidades_bezerras +
          this.peso_medio_vacas * this.vacas_unidades_vacas)) /
      (this.vacas_unidades_machos + this.vacas_unidades_femeas);

    this.peso_medio_total = aux;
  }

  estoque_animal_percentual_cabeca() {
    this.estoque_percentual_cabecas_vacas =
      (this.vacas_unidades_vacas / this.vacas_unidades_total) * 100;
    this.estoque_percentual_cabecas_novilha_3 =
      (this.vacas_unidades_novilhas_3 / this.vacas_unidades_total) * 100;
    this.estoque_percentual_cabecas_novilha_2 =
      (this.vacas_unidades_novilhas_2 / this.vacas_unidades_total) * 100;
    this.estoque_percentual_cabecas_novilha_1 =
      (this.vacas_unidades_novilhas_1 / this.vacas_unidades_total) * 100;
    this.estoque_percentual_cabecas_novilho_3 =
      (this.vacas_unidades_novilhos_3 / this.vacas_unidades_total) * 100;
    this.estoque_percentual_cabecas_novilho_2 =
      (this.vacas_unidades_novilhos_2 / this.vacas_unidades_total) * 100;
    this.estoque_percentual_cabecas_novilho_1 =
      (this.vacas_unidades_novilhos_1 / this.vacas_unidades_total) * 100;
    this.estoque_percentual_cabecas_bezerros =
      (this.vacas_unidades_bezerros / this.vacas_unidades_total) * 100;
    this.estoque_percentual_cabecas_bezerras =
      (this.vacas_unidades_bezerras / this.vacas_unidades_total) * 100;
    this.estoque_percentual_cabecas_touros =
      (this.vacas_unidades_touros / this.vacas_unidades_total) * 100;
    this.estoque_percentual_cabecas_machos =
      (this.vacas_unidades_machos / this.vacas_unidades_total) * 100;
    this.estoque_percentual_cabecas_femeas =
      (this.vacas_unidades_femeas / this.vacas_unidades_total) * 100;
    this.estoque_percentual_cabecas_total =
      (this.vacas_unidades_total / this.vacas_unidades_total) * 100;
  }

  estoque_animal_unidade_area_potencia() {
    this.estoque_unidade_cabecas_vacas =
      (this.peso_medio_vacas / this.unidade_animal) ** 0.75;
    this.estoque_unidade_cabecas_novilha_3 =
      (this.peso_medio_novilha_3 / this.unidade_animal) ** 0.75;
    this.estoque_unidade_cabecas_novilha_2 =
      (this.peso_medio_novilha_2 / this.unidade_animal) ** 0.75;
    this.estoque_unidade_cabecas_novilha_1 =
      (this.peso_medio_novilha_1 / this.unidade_animal) ** 0.75;
    this.estoque_unidade_cabecas_novilho_3 =
      (this.peso_medio_novilho_3 / this.unidade_animal) ** 0.75;
    this.estoque_unidade_cabecas_novilho_2 =
      (this.peso_medio_novilho_2 / this.unidade_animal) ** 0.75;
    this.estoque_unidade_cabecas_novilho_1 =
      (this.peso_medio_novilho_1 / this.unidade_animal) ** 0.75;
    this.estoque_unidade_cabecas_bezerros =
      (this.peso_medio_bezerros / this.unidade_animal) ** 0.75;
    this.estoque_unidade_cabecas_bezerras =
      (this.peso_medio_bezerras / this.unidade_animal) ** 0.75;
    this.estoque_unidade_cabecas_touros =
      (this.peso_medio_touros / this.unidade_animal) ** 0.75;

    this.estoque_unidade_cabecas_machos =
      (this.estoque_unidade_cabecas_novilho_3 * this.vacas_unidades_novilhos_3 +
        this.estoque_unidade_cabecas_novilho_2 *
          this.vacas_unidades_novilhos_2 +
        this.estoque_unidade_cabecas_novilho_1 *
          this.vacas_unidades_novilhos_1 +
        this.estoque_unidade_cabecas_bezerros *
          this.vacas_unidades_bezerros +
        this.estoque_unidade_cabecas_touros * this.vacas_unidades_touros) /
      this.vacas_unidades_machos;

    this.estoque_unidade_cabecas_femeas =
      (this.estoque_unidade_cabecas_novilha_3 * this.vacas_unidades_novilhas_3 +
        this.estoque_unidade_cabecas_novilha_2 *
          this.vacas_unidades_novilhas_2 +
        this.estoque_unidade_cabecas_novilha_1 *
          this.vacas_unidades_novilhas_1 +
        this.estoque_unidade_cabecas_bezerras *
          this.vacas_unidades_bezerras +
        this.estoque_unidade_cabecas_vacas * this.vacas_unidades_vacas) /
      this.vacas_unidades_femeas;
    
    this.estoque_relacao_unidade_por_area =
      this.vacas_unidades_total_UA / this.vacas_unidades_total;
  }

  estoque_animal_unidade_area() {
    this.estoque_percentual_ua_cabecas_vacas =
      this.vacas_unidades_vacas * this.estoque_unidade_cabecas_vacas;
    this.estoque_percentual_ua_cabecas_novilha_3 =
      this.vacas_unidades_novilhas_3 * this.estoque_unidade_cabecas_novilha_3;
    this.estoque_percentual_ua_cabecas_novilha_2 =
      this.vacas_unidades_novilhas_2 * this.estoque_unidade_cabecas_novilha_2;
    this.estoque_percentual_ua_cabecas_novilha_1 =
      this.vacas_unidades_novilhas_1 * this.estoque_unidade_cabecas_novilha_1;
    this.estoque_percentual_ua_cabecas_novilho_3 =
      this.vacas_unidades_novilhos_3 * this.estoque_unidade_cabecas_novilho_3;
    this.estoque_percentual_ua_cabecas_novilho_2 =
      this.vacas_unidades_novilhos_2 * this.estoque_unidade_cabecas_novilho_2;
    this.estoque_percentual_ua_cabecas_novilho_1 =
      this.vacas_unidades_novilhos_1 * this.estoque_unidade_cabecas_novilho_1;
    this.estoque_percentual_ua_cabecas_bezerros =
      this.vacas_unidades_bezerros * this.estoque_unidade_cabecas_bezerros;
    this.estoque_percentual_ua_cabecas_bezerras =
      this.vacas_unidades_bezerras * this.estoque_unidade_cabecas_bezerras;
    this.estoque_percentual_ua_cabecas_touros =
      this.vacas_unidades_touros * this.estoque_unidade_cabecas_touros;

    this.estoque_percentual_ua_cabecas_machos =
      (this.estoque_unidade_cabecas_novilho_3 * this.vacas_unidades_novilhos_3 +
        this.estoque_unidade_cabecas_novilho_2 *
          this.vacas_unidades_novilhos_2 +
        this.estoque_unidade_cabecas_novilho_1 *
          this.vacas_unidades_novilhos_1 +
        this.estoque_unidade_cabecas_bezerros *
          this.vacas_unidades_bezerros +
        this.estoque_unidade_cabecas_touros * this.vacas_unidades_touros) /
      (this.vacas_unidades_total_UA * 100);

    this.estoque_percentual_ua_cabecas_femeas =
      (this.estoque_unidade_cabecas_novilha_3 * this.vacas_unidades_novilhas_3 +
        this.estoque_unidade_cabecas_novilha_2 *
          this.vacas_unidades_novilhas_2 +
        this.estoque_unidade_cabecas_novilha_1 *
          this.vacas_unidades_novilhas_1 +
        this.estoque_unidade_cabecas_bezerras *
          this.vacas_unidades_bezerras +
        this.estoque_unidade_cabecas_vacas * this.vacas_unidades_vacas) /
      (this.vacas_unidades_total_UA * 100);

    this.estoque_percentual_ua_cabecas_total = 100;
  }

  meta_vacas(unidade_vaca) {
    this.vacas_unidades_vacas = unidade_vaca;
    
    // Calcula bezerros: metade do desmame total (sem mortalidade ainda)
    this.vacas_unidades_bezerros = ((this.desmame / 100) * unidade_vaca) / 2;
    
    // Calcula bezerras: metade do desmame total (sem mortalidade ainda)
    this.vacas_unidades_bezerras = ((this.desmame / 100) * unidade_vaca) / 2;
    
    this.vacas_unidades_touros = (this.touros / 100) * unidade_vaca;

    // LÃ³gica de novilhos baseada na idade de venda (machos)
    if (this.idade_venda == 1) {
      // Venda = 1: Vende bezerros direto, nÃ£o tem novilhos
      this.vacas_unidades_novilhos_1 = 0;
      this.vacas_unidades_novilhos_2 = 0;
      this.vacas_unidades_novilhos_3 = 0;
    } else if (this.idade_venda == 2) {
      // Venda = 2: MantÃ©m novilhos_1 (bezerros - mortalidade), vende aos 12-24 meses
      this.vacas_unidades_novilhos_1 = this.vacas_unidades_bezerros - 
        ((this.mortalidade / 100) * this.vacas_unidades_bezerros);
      this.vacas_unidades_novilhos_2 = 0;
      this.vacas_unidades_novilhos_3 = 0;
    } else if (this.idade_venda == 3) {
      // Venda = 3: MantÃ©m novilhos_1 e novilhos_2, vende aos 24-36 meses
      this.vacas_unidades_novilhos_1 = this.vacas_unidades_bezerros - 
        ((this.mortalidade / 100) * this.vacas_unidades_bezerros);
      this.vacas_unidades_novilhos_2 = this.vacas_unidades_novilhos_1 - 
        ((this.mortalidade / 100) * this.vacas_unidades_novilhos_1);
      this.vacas_unidades_novilhos_3 = 0;
    }

    // LÃ³gica de novilhas baseada na idade de entoure (fÃªmeas)
    if (this.idade_entoure == 1) {
      // Entoure = 1: Entram direto na reproduÃ§Ã£o, nÃ£o tem novilhas
      this.vacas_unidades_novilhas_1 = 0;
      this.vacas_unidades_novilhas_2 = 0;
      this.vacas_unidades_novilhas_3 = 0;
    } else if (this.idade_entoure == 2) {
      // Entoure = 2: MantÃ©m novilhas_1 (bezerras - mortalidade)
      this.vacas_unidades_novilhas_1 = this.vacas_unidades_bezerras - 
        ((this.mortalidade / 100) * this.vacas_unidades_bezerras);
      this.vacas_unidades_novilhas_2 = 0;
      this.vacas_unidades_novilhas_3 = 0;
    } else if (this.idade_entoure == 3) {
      // Entoure = 3: MantÃ©m novilhas_1 e novilhas_2
      this.vacas_unidades_novilhas_1 = this.vacas_unidades_bezerras - 
        ((this.mortalidade / 100) * this.vacas_unidades_bezerras);
      this.vacas_unidades_novilhas_2 = this.vacas_unidades_novilhas_1 - 
        ((this.mortalidade / 100) * this.vacas_unidades_novilhas_1);
      this.vacas_unidades_novilhas_3 = 0;
    }

    this.vacas_unidades_machos =
      this.vacas_unidades_novilhos_1 +
      this.vacas_unidades_novilhos_2 +
      this.vacas_unidades_novilhos_3 +
      this.vacas_unidades_bezerros +
      this.vacas_unidades_touros;

    this.vacas_unidades_femeas =
      this.vacas_unidades_novilhas_1 +
      this.vacas_unidades_novilhas_2 +
      this.vacas_unidades_novilhas_3 +
      this.vacas_unidades_bezerras +
      unidade_vaca;

    this.vacas_unidades_total =
      this.vacas_unidades_machos + this.vacas_unidades_femeas;

    this.vacas_unidades_total_UA =
      this.vacas_unidades_vacas * this.estoque_unidade_cabecas_vacas +
      this.vacas_unidades_novilhas_3 * this.estoque_unidade_cabecas_novilha_3 +
      this.vacas_unidades_novilhas_2 * this.estoque_unidade_cabecas_novilha_2 +
      this.vacas_unidades_novilhas_1 * this.estoque_unidade_cabecas_novilha_1 +
      this.vacas_unidades_novilhos_3 * this.estoque_unidade_cabecas_novilho_3 +
      this.vacas_unidades_novilhos_2 * this.estoque_unidade_cabecas_novilho_2 +
      this.vacas_unidades_novilhos_1 * this.estoque_unidade_cabecas_novilho_1 +
      this.vacas_unidades_bezerros * this.estoque_unidade_cabecas_bezerros +
      this.vacas_unidades_bezerras * this.estoque_unidade_cabecas_bezerras +
      this.vacas_unidades_touros * this.estoque_unidade_cabecas_touros;
    this.vacas_area_total = this.vacas_unidades_total_UA / this.lotacao;
  }

  meta_area(unidade_area) {
    this.area_area_total = unidade_area;
    this.area_unidades_total =
      this.area_area_total *
      (this.vacas_unidades_total / this.vacas_area_total);
    this.area_unidades_vacas =
      (this.area_unidades_total * this.estoque_percentual_cabecas_vacas) / 100;

    this.area_unidades_novilhas_3 =
      (this.area_unidades_total * this.estoque_percentual_cabecas_novilha_3) /
      100;
    this.area_unidades_novilhas_2 =
      (this.area_unidades_total * this.estoque_percentual_cabecas_novilha_2) /
      100;
    this.area_unidades_novilhas_1 =
      (this.area_unidades_total * this.estoque_percentual_cabecas_novilha_1) /
      100;
    this.area_unidades_novilhos_3 =
      (this.area_unidades_total * this.estoque_percentual_cabecas_novilho_3) /
      100;
    this.area_unidades_novilhos_2 =
      (this.area_unidades_total * this.estoque_percentual_cabecas_novilho_2) /
      100;
    this.area_unidades_novilhos_1 =
      (this.area_unidades_total * this.estoque_percentual_cabecas_novilho_1) /
      100;
    this.area_unidades_bezerros =
      (this.area_unidades_total * this.estoque_percentual_cabecas_bezerros) /
      100;
    this.area_unidades_bezerras =
      (this.area_unidades_total * this.estoque_percentual_cabecas_bezerras) /
      100;
    this.area_unidades_touros = (this.touros / 100) * this.area_unidades_vacas;
    this.area_unidades_machos =
      (this.area_unidades_total * this.estoque_percentual_cabecas_machos) / 100;
    this.area_unidades_femeas =
      (this.area_unidades_total * this.estoque_percentual_cabecas_femeas) / 100;
    this.area_unidades_total_UA =
      this.area_unidades_vacas * this.estoque_unidade_cabecas_vacas +
      this.area_unidades_novilhas_3 * this.estoque_unidade_cabecas_novilha_3 +
      this.area_unidades_novilhas_2 * this.estoque_unidade_cabecas_novilha_2 +
      this.area_unidades_novilhas_1 * this.estoque_unidade_cabecas_novilha_1 +
      this.area_unidades_novilhos_3 * this.estoque_unidade_cabecas_novilho_3 +
      this.area_unidades_novilhos_2 * this.estoque_unidade_cabecas_novilho_2 +
      this.area_unidades_novilhos_1 * this.estoque_unidade_cabecas_novilho_1 +
      this.area_unidades_bezerros * this.estoque_unidade_cabecas_bezerros +
      this.area_unidades_bezerras * this.estoque_unidade_cabecas_bezerras +
      this.area_unidades_touros * this.estoque_unidade_cabecas_touros;
  }

  meta_tmf(unidade_tmf) {
    // Total de bezerros (machos + fÃªmeas) = unidade_tmf
    this.tmf_unidades_bezerros = unidade_tmf / 2;
    this.tmf_unidades_bezerras = unidade_tmf / 2;
    
    this.tmf_unidades_total =
      (unidade_tmf * 100) /
      (this.estoque_percentual_cabecas_bezerros + this.estoque_percentual_cabecas_bezerras);
    this.tmf_area_total =
      (this.vacas_area_total * this.tmf_unidades_total) /
      this.vacas_unidades_total;
    this.tmf_unidades_vacas =
      (this.tmf_unidades_total * this.estoque_percentual_cabecas_vacas) / 100;
    this.tmf_unidades_novilhas_3 =
      (this.tmf_unidades_total * this.estoque_percentual_cabecas_novilha_3) /
      100;
    this.tmf_unidades_novilhas_2 =
      (this.tmf_unidades_total * this.estoque_percentual_cabecas_novilha_2) /
      100;
    this.tmf_unidades_novilhas_1 =
      (this.tmf_unidades_total * this.estoque_percentual_cabecas_novilha_1) /
      100;
    this.tmf_unidades_novilhos_3 =
      (this.tmf_unidades_total * this.estoque_percentual_cabecas_novilho_3) /
      100;
    this.tmf_unidades_novilhos_2 =
      (this.tmf_unidades_total * this.estoque_percentual_cabecas_novilho_2) /
      100;
    this.tmf_unidades_novilhos_1 =
      (this.tmf_unidades_total * this.estoque_percentual_cabecas_novilho_1) /
      100;
    this.tmf_unidades_touros = (this.touros / 100) * this.tmf_unidades_vacas;
    this.tmf_unidades_machos =
      (this.tmf_unidades_total * this.estoque_percentual_cabecas_machos) / 100;
    this.tmf_unidades_femeas =
      (this.tmf_unidades_total * this.estoque_percentual_cabecas_femeas) / 100;
    this.tmf_unidades_total_UA =
      this.tmf_unidades_vacas * this.estoque_unidade_cabecas_vacas +
      this.tmf_unidades_novilhas_3 * this.estoque_unidade_cabecas_novilha_3 +
      this.tmf_unidades_novilhas_2 * this.estoque_unidade_cabecas_novilha_2 +
      this.tmf_unidades_novilhas_1 * this.estoque_unidade_cabecas_novilha_1 +
      this.tmf_unidades_novilhos_3 * this.estoque_unidade_cabecas_novilho_3 +
      this.tmf_unidades_novilhos_2 * this.estoque_unidade_cabecas_novilho_2 +
      this.tmf_unidades_novilhos_1 * this.estoque_unidade_cabecas_novilho_1 +
      this.tmf_unidades_bezerros * this.estoque_unidade_cabecas_bezerros +
      this.tmf_unidades_bezerras * this.estoque_unidade_cabecas_bezerras +
      this.tmf_unidades_touros * this.estoque_unidade_cabecas_touros;
  }

  meta_novilho_venda(unidade_novilho_venda) {
    if (this.idade_venda == 3) {
      // Vende novilhos_2 (24-36 meses)
      this.novilho_unidades_total =
        (unidade_novilho_venda * 100) /
        this.estoque_percentual_cabecas_novilho_2;
      this.novilho_unidades_novilhos_3 = 0;
      this.novilho_unidades_novilhos_2 = unidade_novilho_venda;
      this.novilho_unidades_novilhos_1 =
        (this.estoque_percentual_cabecas_novilho_1 / 100) *
        this.novilho_unidades_total;
    } else if (this.idade_venda == 2) {
      // Vende novilhos_1 (12-24 meses)
      this.novilho_unidades_total =
        (unidade_novilho_venda * 100) /
        this.estoque_percentual_cabecas_novilho_1;
      this.novilho_unidades_novilhos_3 = 0;
      this.novilho_unidades_novilhos_2 = 0;
      this.novilho_unidades_novilhos_1 = unidade_novilho_venda;
    } else if (this.idade_venda == 1) {
      // Vende bezerros (0-12 meses)
      this.novilho_unidades_total =
        (unidade_novilho_venda * 100) /
        this.estoque_percentual_cabecas_bezerros;
      this.novilho_unidades_novilhos_3 = 0;
      this.novilho_unidades_novilhos_2 = 0;
      this.novilho_unidades_novilhos_1 = 0;
    }

    this.novilho_area_total =
      (this.novilho_unidades_total * this.vacas_area_total) /
      this.vacas_unidades_total;
    this.novilho_unidades_bezerros =
      (this.novilho_unidades_total *
        this.estoque_percentual_cabecas_bezerros) /
      100;
    this.novilho_unidades_bezerras =
      (this.novilho_unidades_total *
        this.estoque_percentual_cabecas_bezerras) /
      100;

    this.novilho_unidades_vacas =
      (this.novilho_unidades_total * this.estoque_percentual_cabecas_vacas) /
      100;
    this.novilho_unidades_novilhas_3 =
      (this.novilho_unidades_total *
        this.estoque_percentual_cabecas_novilha_3) /
      100;
    this.novilho_unidades_novilhas_2 =
      (this.novilho_unidades_total *
        this.estoque_percentual_cabecas_novilha_2) /
      100;
    this.novilho_unidades_novilhas_1 =
      (this.novilho_unidades_total *
        this.estoque_percentual_cabecas_novilha_1) /
      100;

    this.novilho_unidades_touros =
      (this.touros / 100) * this.novilho_unidades_vacas;
    this.novilho_unidades_machos =
      (this.novilho_unidades_total * this.estoque_percentual_cabecas_machos) /
      100;
    this.novilho_unidades_femeas =
      (this.novilho_unidades_total * this.estoque_percentual_cabecas_femeas) /
      100;
    this.novilho_unidades_total_UA =
      this.novilho_unidades_vacas * this.estoque_unidade_cabecas_vacas +
      this.novilho_unidades_novilhas_3 *
        this.estoque_unidade_cabecas_novilha_3 +
      this.novilho_unidades_novilhas_2 *
        this.estoque_unidade_cabecas_novilha_2 +
      this.novilho_unidades_novilhas_1 *
        this.estoque_unidade_cabecas_novilha_1 +
      this.novilho_unidades_novilhos_3 *
        this.estoque_unidade_cabecas_novilho_3 +
      this.novilho_unidades_novilhos_2 *
        this.estoque_unidade_cabecas_novilho_2 +
      this.novilho_unidades_novilhos_1 *
        this.estoque_unidade_cabecas_novilho_1 +
      this.novilho_unidades_bezerros * this.estoque_unidade_cabecas_bezerros +
      this.novilho_unidades_bezerras * this.estoque_unidade_cabecas_bezerras +
      this.novilho_unidades_touros * this.estoque_unidade_cabecas_touros;
  }

  prod_animal_meta_vaca() {
    var auxiliar;

    // Define produÃ§Ã£o de novilhos vendidos baseado na idade de venda
    if (this.idade_venda == 1) {
      // Vende bezerros
      this.prod_vacas_cabeca_novilhos = this.vacas_unidades_bezerros;
    } else if (this.idade_venda == 2) {
      // Vende novilhos_1
      this.prod_vacas_cabeca_novilhos = this.vacas_unidades_novilhos_1;
    } else if (this.idade_venda == 3) {
      // Vende novilhos_2
      this.prod_vacas_cabeca_novilhos = this.vacas_unidades_novilhos_2;
    }

    this.prod_vacas_cabeca_vacas_descarte =
      (this.vacas_unidades_vacas * this.descarte_vacas_ano) / 100;

    this.prod_vacas_cabeca_touros_descarte =
      (this.vacas_unidades_touros * this.descarte_touros_ano) / 100;

    if (this.idade_entoure == 1) {
      auxiliar = this.vacas_unidades_bezerras - this.prod_vacas_cabeca_vacas_descarte;
    } else if (this.idade_entoure == 2) {
      auxiliar = this.vacas_unidades_novilhas_1 - this.prod_vacas_cabeca_vacas_descarte;
    } else {
      auxiliar = this.vacas_unidades_novilhas_2 - this.prod_vacas_cabeca_vacas_descarte;
    }

    this.prod_vacas_cabeca_novilhas = auxiliar;

    this.prod_vacas_cabeca_total_vendas =
      this.prod_vacas_cabeca_novilhos +
      this.prod_vacas_cabeca_novilhas +
      this.prod_vacas_cabeca_vacas_descarte +
      this.prod_vacas_cabeca_touros_descarte;
  }

  prod_animal_meta_area() {
    var auxiliar;
    
    // Define produÃ§Ã£o de novilhos vendidos baseado na idade de venda
    if (this.idade_venda == 1) {
      // Vende bezerros
      this.prod_area_cabeca_novilhos = this.area_unidades_bezerros;
    } else if (this.idade_venda == 2) {
      // Vende novilhos_1
      this.prod_area_cabeca_novilhos = this.area_unidades_novilhos_1;
    } else if (this.idade_venda == 3) {
      // Vende novilhos_2
      this.prod_area_cabeca_novilhos = this.area_unidades_novilhos_2;
    }

    this.prod_area_cabeca_vacas_descarte =
      (this.area_unidades_vacas * this.descarte_vacas_ano) / 100;
    this.prod_area_cabeca_touros_descarte =
      (this.area_unidades_touros * this.descarte_touros_ano) / 100;

    if (this.idade_entoure == 1) {
      auxiliar = this.area_unidades_bezerras - this.prod_area_cabeca_vacas_descarte;
    } else if (this.idade_entoure == 2) {
      auxiliar = this.area_unidades_novilhas_1 - this.prod_area_cabeca_vacas_descarte;
    } else {
      auxiliar = this.area_unidades_novilhas_2 - this.prod_area_cabeca_vacas_descarte;
    }

    this.prod_area_cabeca_novilhas = auxiliar;

    this.prod_area_cabeca_total_vendas =
      this.prod_area_cabeca_novilhos +
      this.prod_area_cabeca_novilhas +
      this.prod_area_cabeca_vacas_descarte +
      this.prod_area_cabeca_touros_descarte;
  }

  prod_animal_meta_tmf() {
    var auxiliar;

    // Define produÃ§Ã£o de novilhos vendidos baseado na idade de venda
    if (this.idade_venda == 1) {
      // Vende bezerros
      this.prod_tmf_cabeca_novilhos = this.tmf_unidades_bezerros;
    } else if (this.idade_venda == 2) {
      // Vende novilhos_1
      this.prod_tmf_cabeca_novilhos = this.tmf_unidades_novilhos_1;
    } else if (this.idade_venda == 3) {
      // Vende novilhos_2
      this.prod_tmf_cabeca_novilhos = this.tmf_unidades_novilhos_2;
    }

    this.prod_tmf_cabeca_vacas_descarte =
      (this.tmf_unidades_vacas * this.descarte_vacas_ano) / 100;

    this.prod_tmf_cabeca_touros_descarte =
      (this.tmf_unidades_touros * this.descarte_touros_ano) / 100;

    if (this.idade_entoure == 1) {
      auxiliar = this.tmf_unidades_bezerras - this.prod_tmf_cabeca_vacas_descarte;
    } else if (this.idade_entoure == 2) {
      auxiliar = this.tmf_unidades_novilhas_1 - this.prod_tmf_cabeca_vacas_descarte;
    } else {
      auxiliar = this.tmf_unidades_novilhas_2 - this.prod_tmf_cabeca_vacas_descarte;
    }

    this.prod_tmf_cabeca_novilhas = auxiliar;

    this.prod_tmf_cabeca_total_vendas =
      this.prod_tmf_cabeca_novilhos +
      this.prod_tmf_cabeca_novilhas +
      this.prod_tmf_cabeca_vacas_descarte +
      this.prod_tmf_cabeca_touros_descarte;
  }

  prod_animal_meta_novilho() {
    var auxiliar;

    // Define produÃ§Ã£o de novilhos vendidos baseado na idade de venda
    if (this.idade_venda == 1) {
      // Vende bezerros
      this.prod_novilho_cabeca_novilhos = this.novilho_unidades_bezerros;
    } else if (this.idade_venda == 2) {
      // Vende novilhos_1
      this.prod_novilho_cabeca_novilhos = this.novilho_unidades_novilhos_1;
    } else if (this.idade_venda == 3) {
      // Vende novilhos_2
      this.prod_novilho_cabeca_novilhos = this.novilho_unidades_novilhos_2;
    }

    this.prod_novilho_cabeca_vacas_descarte =
      (this.novilho_unidades_vacas * this.descarte_vacas_ano) / 100;
    this.prod_novilho_cabeca_touros_descarte =
      (this.novilho_unidades_touros * this.descarte_touros_ano) / 100;

    if (this.idade_entoure == 1) {
      auxiliar = this.novilho_unidades_bezerras - this.prod_novilho_cabeca_vacas_descarte;
    } else if (this.idade_entoure == 2) {
      auxiliar = this.novilho_unidades_novilhas_1 - this.prod_novilho_cabeca_vacas_descarte;
    } else {
      auxiliar = this.novilho_unidades_novilhas_2 - this.prod_novilho_cabeca_vacas_descarte;
    }

    this.prod_novilho_cabeca_novilhas = auxiliar;

    this.prod_novilho_cabeca_total_vendas =
      this.prod_novilho_cabeca_novilhos +
      this.prod_novilho_cabeca_novilhas +
      this.prod_novilho_cabeca_vacas_descarte +
      this.prod_novilho_cabeca_touros_descarte;
  }

  efic_cria() {
    this.efic_cria_kgTerneiro_kgUnidProd =
      (((this.area_unidades_bezerros + this.area_unidades_bezerras) * this.peso_medio_bezerros) /
        (this.area_unidades_vacas * this.peso_medio_vacas +
          this.area_unidades_novilhas_3 * this.peso_medio_novilha_3 +
          this.area_unidades_novilhas_2 * this.peso_medio_novilha_2 +
          this.area_unidades_novilhas_1 * this.peso_medio_novilha_1 +
          this.area_unidades_touros * this.peso_medio_touros)) *
      100;

    this.desfrute_percentual_cabeca =
      (this.prod_area_cabeca_total_vendas / this.area_unidades_total) * 100;

    this.cria_femeas_bezerro =
      (this.area_unidades_vacas +
        this.area_unidades_novilhas_3 +
        this.area_unidades_novilhas_2 +
        this.area_unidades_novilhos_1) /
      (this.area_unidades_bezerros + this.area_unidades_bezerras);

    /*-----------------------------------------------------------------------------------------------------*/
    // Calcula venda de novilhas (fÃªmeas) baseado na idade de entoure
    if (this.idade_entoure == 1) {
      // Entoure direto: vende bezerras excedentes
      var parte_1 =
        (this.area_unidades_bezerras -
          (this.descarte_vacas_ano / 100) * this.area_unidades_vacas) *
        this.peso_venda_bezerras;
    } else if (this.idade_entoure == 2) {
      // Entoure aos 12-24 meses: vende novilhas_1 excedentes
      var parte_1 =
        (this.area_unidades_novilhas_1 -
          (this.descarte_vacas_ano / 100) * this.area_unidades_vacas) *
        this.peso_venda_novilha_1;
    } else {
      // Entoure aos 24-36 meses: vende novilhas_2 excedentes
      var parte_1 =
        (this.area_unidades_novilhas_2 -
          (this.descarte_vacas_ano / 100) * this.area_unidades_vacas) *
        this.peso_venda_novilha_2;
    }

    // Calcula venda de novilhos (machos) baseado na idade de venda
    if (this.idade_venda == 1) {
      // Vende bezerros
      var parte_2 = this.area_unidades_bezerros * this.peso_venda_bezerros;
    } else if (this.idade_venda == 2) {
      // Vende novilhos_1
      var parte_2 = this.area_unidades_novilhos_1 * this.peso_venda_novilho_1;
    } else {
      // Vende novilhos_2
      var parte_2 = this.area_unidades_novilhos_2 * this.peso_venda_novilho_2;
    }
    var desc_touros =
      this.area_unidades_touros *
      (this.descarte_touros_ano / 100) *
      this.peso_venda_touros;
    var desc_vacas =
      (this.descarte_vacas_ano / 100) *
      this.area_unidades_vacas *
      this.peso_venda_vacas;

    this.produtividade_por_area =
      (parte_1 + desc_touros + parte_2 + desc_vacas) / this.area_area_total;
    /*-----------------------------------------------------------------------------------------------------*/

    var parte_3 =
      this.area_unidades_vacas * this.peso_medio_vacas +
      this.area_unidades_novilhas_3 * this.peso_medio_novilha_3 +
      this.area_unidades_novilhas_2 * this.peso_medio_novilha_2 +
      this.area_unidades_novilhas_1 * this.peso_medio_novilha_1 +
      this.area_unidades_novilhos_3 * this.peso_medio_novilho_3 +
      this.area_unidades_novilhos_2 * this.peso_medio_novilho_2 +
      this.area_unidades_novilhos_1 * this.peso_medio_novilho_1 +
      this.area_unidades_bezerros * this.peso_medio_bezerros +
      this.area_unidades_bezerras * this.peso_medio_bezerras +
      this.area_unidades_touros * this.peso_medio_touros;

    this.desfrute_percentual_kg =
      ((parte_1 + desc_touros + parte_2 + desc_vacas) / parte_3) * 100;
  }

  produtividade_terneiros() {
    const total_terneiros = (this.vacas_unidades_bezerros || 0) + (this.vacas_unidades_bezerras || 0);
    const divisor_terneiros = total_terneiros || 1;
    const divisor_total_ua = (this.vacas_unidades_total_UA || 1);
    const divisor_vacas = this.vacas_unidades_vacas || 1;
    const divisor_peso_vacas = ((this.vacas_unidades_vacas * this.peso_medio_vacas) / 100) || 1;
    const lotacao_val = this.lotacao || 0.7;

    this.prod_cria_relacao_femeas_terneiro = 
      ((this.vacas_unidades_novilhas_1 || 0) + 
       (this.vacas_unidades_novilhas_2 || 0) + 
       (this.vacas_unidades_novilhas_3 || 0) + 
       (this.vacas_unidades_vacas || 0)) / divisor_terneiros;

    this.prod_cria_peso_terneiro_desm_hectare = 
      (total_terneiros * (this.peso_venda_bezerros || 180)) / (divisor_total_ua / lotacao_val);

    this.prod_cria_area_prod_terneiro = 
      (divisor_total_ua / lotacao_val) / divisor_terneiros;

    this.prod_cria_bezerros_desm_vaca_exposta = 
      (total_terneiros * (this.peso_venda_bezerros || 180)) / divisor_vacas;

    this.prod_cria_bezerros_desm_kg_vaca_exposta = 
      (total_terneiros * (this.peso_venda_bezerros || 180)) / divisor_peso_vacas;

    const peso_total_rebanho = 
      (this.vacas_unidades_vacas || 0) * (this.peso_medio_vacas || 450) +
      (this.vacas_unidades_novilhas_3 || 0) * (this.peso_medio_novilha_3 || 370) +
      (this.vacas_unidades_novilhas_2 || 0) * (this.peso_medio_novilha_2 || 370) +
      (this.vacas_unidades_novilhas_1 || 0) * (this.peso_medio_novilha_1 || 270) +
      (this.vacas_unidades_touros || 0) * (this.peso_medio_touros || 650);
    const divisor_peso_rebanho = peso_total_rebanho || 1;

    this.efic_cria_kgTerneiro_kgUnidProd = 
      ((total_terneiros * (this.peso_venda_bezerros || 180)) / divisor_peso_rebanho) * 100;

    const divisor_area_total = this.vacas_area_total || 1;
    this.lotacao_cab_area = this.vacas_unidades_total / divisor_area_total;
  }

  estoque_animal_unidade_vacas_potencia_cria() {
    this.estoque_unidade_cabecas_vacas =
      (this.peso_medio_vacas / this.unidade_animal) ** 0.75;
    
    this.estoque_unidade_cabecas_novilha_3 = 0;

    this.estoque_unidade_cabecas_novilha_2 =
      (this.peso_medio_novilha_2 / this.unidade_animal) ** 0.75;
    this.estoque_unidade_cabecas_novilha_1 =
      (this.peso_medio_novilha_1 / this.unidade_animal) ** 0.75;
    this.estoque_unidade_cabecas_bezerros =
      (this.peso_medio_bezerros / this.unidade_animal) ** 0.75;
    this.estoque_unidade_cabecas_bezerras =
      (this.peso_medio_bezerras / this.unidade_animal) ** 0.75;
    this.estoque_unidade_cabecas_touros =
      (this.peso_medio_touros / this.unidade_animal) ** 0.75;

    this.estoque_unidade_cabecas_machos =
      (this.estoque_unidade_cabecas_bezerros *
          this.vacas_unidades_bezerros +
        this.estoque_unidade_cabecas_touros * this.vacas_unidades_touros) /
      this.vacas_unidades_machos;

    this.estoque_unidade_cabecas_femeas =
      (this.estoque_unidade_cabecas_novilha_3 * this.vacas_unidades_novilhas_3 +
        this.estoque_unidade_cabecas_novilha_2 *
          this.vacas_unidades_novilhas_2 +
        this.estoque_unidade_cabecas_novilha_1 *
          this.vacas_unidades_novilhas_1 +
        this.estoque_unidade_cabecas_bezerras *
          this.vacas_unidades_bezerras +
        this.estoque_unidade_cabecas_vacas * this.vacas_unidades_vacas) /
      this.vacas_unidades_femeas;

    this.estoque_relacao_unidade_por_area =
      this.vacas_unidades_total_UA / this.vacas_unidades_total;
  }

  estoque_animal_percentual_ua_cria() {
    this.estoque_percentual_ua_cabecas_vacas =
      ((this.vacas_unidades_vacas * this.estoque_unidade_cabecas_vacas)/ this.vacas_unidades_total_UA)*100;

    this.estoque_percentual_ua_cabecas_novilha_3 = 0;

    this.estoque_percentual_ua_cabecas_novilha_2 =
      ((this.vacas_unidades_novilhas_2 * this.estoque_unidade_cabecas_novilha_2)/ this.vacas_unidades_total_UA)*100;

    this.estoque_percentual_ua_cabecas_novilha_1 =
      ((this.vacas_unidades_novilhas_1 * this.estoque_unidade_cabecas_novilha_1)/ this.vacas_unidades_total_UA)*100;

    this.estoque_percentual_ua_cabecas_bezerros =
      ((this.vacas_unidades_bezerros * this.estoque_unidade_cabecas_bezerros)/ this.vacas_unidades_total_UA)*100;

    this.estoque_percentual_ua_cabecas_bezerras =
      ((this.vacas_unidades_bezerras * this.estoque_unidade_cabecas_bezerras)/ this.vacas_unidades_total_UA)*100;

    this.estoque_percentual_ua_cabecas_touros =
      ((this.vacas_unidades_touros * this.estoque_unidade_cabecas_touros)/ this.vacas_unidades_total_UA)*100;

    this.estoque_percentual_ua_cabecas_machos =
      ((this.estoque_unidade_cabecas_bezerros *
          this.vacas_unidades_bezerros +
        this.estoque_unidade_cabecas_touros * this.vacas_unidades_touros) /
      (this.vacas_unidades_total_UA ))*100;

    this.estoque_percentual_ua_cabecas_femeas =
        ((this.estoque_unidade_cabecas_novilha_2 *
          this.vacas_unidades_novilhas_2 +
        this.estoque_unidade_cabecas_novilha_1 *
          this.vacas_unidades_novilhas_1 +
        this.estoque_unidade_cabecas_bezerras *
          this.vacas_unidades_bezerras +
        this.estoque_unidade_cabecas_vacas * this.vacas_unidades_vacas) /
      (this.vacas_unidades_total_UA ))*100;

    this.estoque_percentual_ua_cabecas_total = 100;
  }

  meta_vacas_cria(unidade_vaca) {
    this.vacas_unidades_vacas = unidade_vaca;
    
    this.vacas_unidades_bezerros = ((this.desmame / 100) * unidade_vaca) / 2;
    this.vacas_unidades_bezerras = ((this.desmame / 100) * unidade_vaca) / 2;
    this.vacas_unidades_touros = (this.touros / 100) * unidade_vaca;

    this.vacas_unidades_novilhos_1 = 0;
    this.vacas_unidades_novilhos_2 = 0;
    this.vacas_unidades_novilhos_3 = 0;

    if (this.idade_entoure == 1) {
      // Idade 1: Entoure direto, sem novilhas
      this.vacas_unidades_novilhas_1 = 0;
      this.vacas_unidades_novilhas_2 = 0;
      this.vacas_unidades_novilhas_3 = 0;
    } else if (this.idade_entoure == 2) {
      // Idade 2: Apenas novilhas de 1 ano
      this.vacas_unidades_novilhas_1 = this.vacas_unidades_bezerras - ((this.mortalidade / 100) * this.vacas_unidades_bezerras);
      this.vacas_unidades_novilhas_2 = 0;
      this.vacas_unidades_novilhas_3 = 0;
    } else if (this.idade_entoure == 3) {
      // Idade 3: Novilhas de 1 e 2 anos
      this.vacas_unidades_novilhas_1 = this.vacas_unidades_bezerras - ((this.mortalidade / 100) * this.vacas_unidades_bezerras);
      this.vacas_unidades_novilhas_2 = this.vacas_unidades_novilhas_1 - ((this.mortalidade / 100) * this.vacas_unidades_novilhas_1);
      this.vacas_unidades_novilhas_3 = 0;
    }

    this.vacas_unidades_machos =
      this.vacas_unidades_bezerros +
      this.vacas_unidades_touros;

    this.vacas_unidades_femeas =
      this.vacas_unidades_novilhas_1 +
      this.vacas_unidades_novilhas_2 +
      this.vacas_unidades_novilhas_3 +
      this.vacas_unidades_bezerras +
      unidade_vaca;

    this.vacas_unidades_total =
      this.vacas_unidades_machos + this.vacas_unidades_femeas;
    
    this.vacas_unidades_total_UA =
      this.vacas_unidades_vacas * this.estoque_unidade_cabecas_vacas +
      this.vacas_unidades_novilhas_3 * this.estoque_unidade_cabecas_novilha_3 +
      this.vacas_unidades_novilhas_2 * this.estoque_unidade_cabecas_novilha_2 +
      this.vacas_unidades_novilhas_1 * this.estoque_unidade_cabecas_novilha_1 +
      this.vacas_unidades_bezerros * this.estoque_unidade_cabecas_bezerros +
      this.vacas_unidades_bezerras * this.estoque_unidade_cabecas_bezerras +
      this.vacas_unidades_touros * this.estoque_unidade_cabecas_touros;
    this.vacas_area_total = this.vacas_unidades_total_UA / this.lotacao;
  }

  meta_area_cria(area_disponivel) {
    // Calcula o nÃºmero de UA que cabem na Ã¡rea disponÃ­vel
    this.area_area_total = area_disponivel;
    this.area_unidades_total = (area_disponivel * (this.vacas_unidades_total / this.vacas_area_total ));

    this.area_unidades_vacas = this.area_unidades_total * this.estoque_percentual_cabecas_vacas / 100;
    this.area_unidades_novilhas_1 = this.area_unidades_total * this.estoque_percentual_cabecas_novilha_1 / 100;
    this.area_unidades_novilhas_2 = this.area_unidades_total * this.estoque_percentual_cabecas_novilha_2 / 100;
    this.area_unidades_novilhas_3 = 0;
    this.area_unidades_bezerros = this.area_unidades_total * this.estoque_percentual_cabecas_bezerros / 100;
    this.area_unidades_bezerras = this.area_unidades_total * this.estoque_percentual_cabecas_bezerras / 100;
    this.area_unidades_touros = this.area_unidades_vacas * (this.touros / 100);
    this.area_unidades_machos = this.area_unidades_bezerros + this.area_unidades_touros;
    this.area_unidades_femeas = this.area_unidades_vacas + this.area_unidades_novilhas_1 + this.area_unidades_novilhas_2 + this.area_unidades_bezerras;
    this.area_unidades_total_UA = (this.area_unidades_vacas * this.estoque_unidade_cabecas_vacas) + 
      (this.area_unidades_novilhas_2 * this.estoque_unidade_cabecas_novilha_2) +
      (this.area_unidades_novilhas_1 * this.estoque_unidade_cabecas_novilha_1) +
      (this.area_unidades_bezerros * this.estoque_unidade_cabecas_bezerros) +
      (this.area_unidades_bezerras * this.estoque_unidade_cabecas_bezerras) +
      (this.area_unidades_touros * this.estoque_unidade_cabecas_touros);
  }

  calcula_peso_medio_machos_cria() {
    var aux =
      (this.peso_medio_bezerros * this.vacas_unidades_bezerros +
        this.peso_medio_touros * this.vacas_unidades_touros) /
      this.vacas_unidades_machos;
    this.peso_medio_machos = aux;
  }

  calcula_peso_medio_femeas_cria() {
    var aux =
      (this.peso_medio_novilha_1 * this.vacas_unidades_novilhas_1 +
        this.peso_medio_novilha_2 * this.vacas_unidades_novilhas_2 +
        this.peso_medio_novilha_3 * this.vacas_unidades_novilhas_3 +
        this.peso_medio_bezerras * this.vacas_unidades_bezerras +
        this.peso_medio_vacas * this.vacas_unidades_vacas) /
      this.vacas_unidades_femeas;
    this.peso_medio_femeas = aux;
  }

  calcula_peso_medio_total_cria() {
    var aux =
      (this.peso_medio_bezerros * this.vacas_unidades_bezerros +
        this.peso_medio_touros * this.vacas_unidades_touros +
        (this.peso_medio_novilha_1 * this.vacas_unidades_novilhas_1 +
          this.peso_medio_novilha_2 * this.vacas_unidades_novilhas_2 +
          this.peso_medio_bezerras * this.vacas_unidades_bezerras +
          this.peso_medio_vacas * this.vacas_unidades_vacas)) /
      (this.vacas_unidades_machos + this.vacas_unidades_femeas);

    this.peso_medio_total = aux;
  }

  estoque_animal_percentual_cabeca_cria() {
    this.estoque_percentual_cabecas_vacas =
      (this.vacas_unidades_vacas / this.vacas_unidades_total) * 100;
    this.estoque_percentual_cabecas_novilha_3 = 0;
    this.estoque_percentual_cabecas_novilha_2 =
      (this.vacas_unidades_novilhas_2 / this.vacas_unidades_total) * 100;
    this.estoque_percentual_cabecas_novilha_1 =
      (this.vacas_unidades_novilhas_1 / this.vacas_unidades_total) * 100;
    this.estoque_percentual_cabecas_bezerros =
      (this.vacas_unidades_bezerros / this.vacas_unidades_total) * 100;
    this.estoque_percentual_cabecas_bezerras =
      (this.vacas_unidades_bezerras / this.vacas_unidades_total) * 100;
    this.estoque_percentual_cabecas_touros =
      (this.vacas_unidades_touros / this.vacas_unidades_total) * 100;
    this.estoque_percentual_cabecas_machos =
      (this.vacas_unidades_machos / this.vacas_unidades_total) * 100;
    this.estoque_percentual_cabecas_femeas =
      (this.vacas_unidades_femeas / this.vacas_unidades_total) * 100;
    this.estoque_percentual_cabecas_total =
      (this.vacas_unidades_total / this.vacas_unidades_total) * 100;
  }

  prod_animal_meta_area_cria(){
    this.prod_area_cabeca_vacas_descarte =
      (this.area_unidades_vacas * this.descarte_vacas_ano) / 100;

    this.prod_area_cabeca_touros_descarte =
      (this.area_unidades_touros * this.descarte_touros_ano) / 100;

    if (this.idade_entoure == 1) {
      this.prod_area_cabeca_novilhas = this.area_unidades_bezerras - this.prod_area_cabeca_vacas_descarte;
    } else if (this.idade_entoure == 2) {      
        this.prod_area_cabeca_novilhas = this.area_unidades_novilhas_1 - this.prod_area_cabeca_vacas_descarte;
      } else {
        this.prod_area_cabeca_novilhas = this.area_unidades_novilhas_2 - this.prod_area_cabeca_vacas_descarte;
      }

    this.prod_area_cabeca_bezerros = this.area_unidades_bezerros;
    this.prod_area_cabeca_novilhos = this.prod_area_cabeca_bezerros; // For compatibility with app UI which uses novilhos

    this.prod_area_cabeca_total_vendas =
      this.prod_area_cabeca_bezerros +
      this.prod_area_cabeca_novilhas +
      this.prod_area_cabeca_vacas_descarte +
      this.prod_area_cabeca_touros_descarte;
  }

  prod_animal_meta_vaca_cria() {
    this.prod_vacas_cabeca_vacas_descarte =
      (this.vacas_unidades_vacas * this.descarte_vacas_ano) / 100;

    this.prod_vacas_cabeca_touros_descarte =
      (this.vacas_unidades_touros * this.descarte_touros_ano) / 100;

    if (this.idade_entoure == 1) {
      this.prod_vacas_cabeca_novilhas = this.vacas_unidades_bezerras - this.prod_vacas_cabeca_vacas_descarte;
    } else if (this.idade_entoure == 2) {      
        this.prod_vacas_cabeca_novilhas = this.vacas_unidades_novilhas_1 - this.prod_vacas_cabeca_vacas_descarte;
      } else {
        this.prod_vacas_cabeca_novilhas = this.vacas_unidades_novilhas_2 - this.prod_vacas_cabeca_vacas_descarte;
      }

    this.prod_vacas_cabeca_bezerros = this.vacas_unidades_bezerros;
    this.prod_vacas_cabeca_novilhos = this.prod_vacas_cabeca_bezerros; // For compatibility

    this.prod_vacas_cabeca_total_vendas =
      this.prod_vacas_cabeca_bezerros +
      this.prod_vacas_cabeca_novilhas +
      this.prod_vacas_cabeca_vacas_descarte +
      this.prod_vacas_cabeca_touros_descarte;
  }

  efic_cria_cria() {
    // Desfrute em kg por cabeÃ§a
    // Parte 1: Venda de Novilhas (condicional baseado em idade de entoure)
    let pesoVendaNovilhas;
    if (this.vacas_unidades_novilhas_2 == 0 && this.vacas_unidades_novilhas_1 == 0) {
      // Entoure aos 1 ano
      pesoVendaNovilhas = (this.vacas_unidades_bezerras - this.prod_vacas_cabeca_vacas_descarte) * this.peso_venda_bezerras;
    } else if (this.vacas_unidades_novilhas_2 == 0) {
      // Entoure aos 2 anos
      pesoVendaNovilhas = (this.vacas_unidades_novilhas_1 - this.prod_vacas_cabeca_vacas_descarte) * this.peso_venda_novilha_1;
    } else {
      // Entoure aos 3 anos
      pesoVendaNovilhas = (this.vacas_unidades_novilhas_2 - this.prod_vacas_cabeca_vacas_descarte) * this.peso_venda_novilha_2;
    }
    
    // Parte 2: Venda de Bezerros machos
    const pesoVendaTerneiros = this.vacas_unidades_bezerros * this.peso_venda_bezerros;
    
    // Parte 3: Descarte de Vacas
    const pesoDescarteVacas = this.prod_vacas_cabeca_vacas_descarte * this.peso_venda_vacas;
    
    // Parte 4: Descarte de Touros
    const pesoDescarteTouros = (this.vacas_unidades_touros * this.descarte_touros_ano/100) * this.peso_venda_touros;
    
    // NUMERADOR: Peso total vendido
    const pesoTotalVendido = pesoVendaNovilhas + pesoVendaTerneiros + pesoDescarteVacas + pesoDescarteTouros;
    
    // DENOMINADOR: Peso total do rebanho
    const pesoTotalRebanho = 
      (this.vacas_unidades_vacas * this.peso_medio_vacas) + 
      (this.vacas_unidades_novilhas_2 * this.peso_medio_novilha_2) +
      (this.vacas_unidades_novilhas_1 * this.peso_medio_novilha_1) + 
      (this.vacas_unidades_bezerros * this.peso_medio_bezerros) + 
      (this.vacas_unidades_bezerras * this.peso_medio_bezerras) + 
      (this.vacas_unidades_touros * this.peso_medio_touros);
    
    // Desfrute percentual em kg
    this.desfrute_percentual_kg = (pesoTotalVendido / pesoTotalRebanho) * 100;
    this.desfrute_percentual_cabeca = (this.prod_vacas_cabeca_total_vendas / this.vacas_unidades_total) * 100;
    this.produtividade_por_area = pesoTotalVendido / this.vacas_area_total;
  }

  produtividade_terneiros_cria() {
    this.prod_cria_relacao_femeas_terneiro= (this.vacas_unidades_novilhas_1 + this.vacas_unidades_novilhas_2 + this.vacas_unidades_novilhas_3 + this.vacas_unidades_vacas) / (this.vacas_unidades_bezerros + this.vacas_unidades_bezerras);
    this.prod_cria_peso_terneiro_desm_hectare= ((this.vacas_unidades_bezerros + this.vacas_unidades_bezerras) * ((this.peso_venda_bezerros + this.peso_venda_bezerras)/2)) / (this.vacas_unidades_total_UA / this.lotacao);
    this.prod_cria_area_prod_terneiro=(this.vacas_unidades_total_UA / this.lotacao) / (this.vacas_unidades_bezerros + this.vacas_unidades_bezerras);
    this.prod_cria_bezerros_desm_vaca_exposta =
      ((this.peso_venda_bezerros * this.area_unidades_bezerros) +
        (this.peso_venda_bezerras * this.area_unidades_bezerras)) /
      this.area_unidades_vacas;
    this.prod_cria_bezerros_desm_kg_vaca_exposta =
      ((this.peso_venda_bezerros + this.peso_venda_bezerras) / 2) /
      (this.peso_medio_vacas / 100);
    this.efic_cria_kgTerneiro_kgUnidProd =
      (((this.vacas_unidades_bezerros + this.vacas_unidades_bezerras) * ((this.peso_venda_bezerros + this.peso_venda_bezerras)/2)) /
        (this.vacas_unidades_vacas * this.peso_medio_vacas +
          this.vacas_unidades_novilhas_3 * this.peso_medio_novilha_3 +
          this.vacas_unidades_novilhas_2 * this.peso_medio_novilha_2 +
          this.vacas_unidades_novilhas_1 * this.peso_medio_novilha_1 +
          this.vacas_unidades_touros * this.peso_medio_touros)) *
      100;
    this.lotacao_cab_area = this.vacas_unidades_total / this.vacas_area_total;
  }

  executa_simulador(valor_metas) {
    if (this.is_cria()) {
      this.estoque_animal_unidade_vacas_potencia_cria();
      this.meta_vacas_cria(valor_metas.vacas);
      this.estoque_animal_unidade_vacas_potencia_cria();
      this.calcula_peso_medio_machos_cria();
      this.calcula_peso_medio_femeas_cria();
      this.calcula_peso_medio_total_cria();
      this.estoque_animal_percentual_ua_cria();
      this.estoque_animal_percentual_cabeca_cria();
      this.meta_area_cria(valor_metas.area);
      this.meta_tmf(valor_metas.tmf);
      this.meta_novilho_venda(valor_metas.novilho);
      this.prod_animal_meta_vaca_cria();
      this.prod_animal_meta_area_cria();
      this.prod_animal_meta_tmf();
      this.prod_animal_meta_novilho();
      this.efic_cria_cria();
      this.produtividade_terneiros_cria();
    } else {
      this.estoque_animal_unidade_area_potencia();
      this.meta_vacas(valor_metas.vacas);
      this.estoque_animal_unidade_area_potencia();
      this.calcula_peso_medio_machos();
      this.calcula_peso_medio_femeas();
      this.calcula_peso_medio_total();
      this.estoque_animal_unidade_area();
      this.estoque_animal_percentual_cabeca();
      this.meta_area(valor_metas.area);
      this.meta_tmf(valor_metas.tmf);
      this.meta_novilho_venda(valor_metas.novilho);
      this.prod_animal_meta_vaca();
      this.prod_animal_meta_area();
      this.prod_animal_meta_tmf();
      this.prod_animal_meta_novilho();
      this.efic_cria();
      this.produtividade_terneiros();
    }

  }
}

function valor_produtividade(simulador, valor_por_kg) {
  var resultado_por_kg;

  resultado_por_kg = simulador.produtividade_por_area * valor_por_kg;

  return resultado_por_kg;
}

function diferenca_cenarios(
  cenario_1,
  cenario_2,
  valor_por_kg_cenario_1,
  valor_por_kg_cenario_2
) {
  var diferenca_cenarios;

  diferenca_cenarios =
    valor_produtividade(cenario_1, valor_por_kg_cenario_1) -
    valor_produtividade(cenario_2, valor_por_kg_cenario_2);

  return diferenca_cenarios;
}
